import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-taocan",
  "use": "icon-icon-taocan-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-taocan\">\r\n<g id=\"icon-icon-taocan_icon-&#229;&#165;&#151;&#233;&#164;&#144;&#231;&#174;&#161;&#231;&#144;&#134;\">\r\n<path id=\"icon-icon-taocan_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 1H2V12C2 13.6569 3.34315 15 5 15H14V1ZM2 0H1V1V12C1 14.2091 2.79086 16 5 16H14H15V15V1V0H14H2ZM8 6H4V5H8V6ZM4 9V10H12V9H4Z\" fill=\"#555555\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol